// VUE plugin components (plugin type 4) of the query plugin panel. Shared by Query.vue (panel /
// action result popup) and Plugin.vue (action result in a new tab, #897), so both resolve the same
// plugin.url names.
import GMapDistrictBorder from './gmap/GMapDistrictBorder.vue'
import GMapTownBorder from './gmap/GMapTownBorder.vue'
import GMapRegionBorder from './gmap/GMapRegionBorder.vue'
import GMapMarkers from './gmap/GMapMarkers.vue'
import GMapKMLLayers from './gmap/GMapKMLLayers.vue'
import CoolingUnitCallConfigQuery from './servoking/CoolingUnitCallConfigQuery.vue'
import RedirectToDashboard from './teletec/RedirectToDashboard.vue'

export const QUERY_PLUGIN_COMPONENTS = Object.freeze({
  GMapDistrictBorder,
  GMapTownBorder,
  GMapRegionBorder,
  GMapMarkers,
  GMapKMLLayers,
  CoolingUnitCallConfigQuery,
  RedirectToDashboard
})
